import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserProfile } from '../../contexts/user/hooks';

const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

// Routes accessible without active subscription
const SUBSCRIPTION_EXEMPT_PATHS = ['/app/billing', '/app/profile', '/app/support'];

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Check subscription status for non-exempt routes
  const isExempt = SUBSCRIPTION_EXEMPT_PATHS.some(path => location.pathname.startsWith(path));

  if (!isExempt) {
    return <SubscriptionGate>{children}</SubscriptionGate>;
  }

  return <>{children}</>;
};

const SubscriptionGate = ({ children }: { children: React.ReactNode }) => {
  const { profile, isLoading } = useUserProfile();

  // Wait for profile to load
  if (isLoading || !profile) {
    return <>{children}</>;
  }

  // Owner and admin bypass subscription check
  if (profile.role === 'owner' || profile.role === 'admin') {
    return <>{children}</>;
  }

  // Active subscription required
  if (profile.subscriptionStatus !== 'active') {
    return <Navigate to="/app/billing" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
